/* This example requires Tailwind CSS v2.0+ */
import {Fragment, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {LocationMarkerIcon, PhoneIcon, XIcon} from '@heroicons/react/outline'
import {GoogleMapsWidget} from "./GoogleMapsWidget";
import {AppDownloadBanner} from "./AppDownloadBanner";
import {ASSETS_BASE_URL} from "./constants";

export function CompanyDetailsModal(
    {
        show = false,
        setOpen,
        currentItem
    }
) {

    const [visible, setVisible] = useState(false);

    if (show) {
        setTimeout(() => {
            setVisible(true);
        })
    }

    const closeModal = () => {
        setVisible(false);
        setOpen(null)
    };
    return !currentItem ? (<></>) : (
        <Transition.Root show={visible} as={Fragment}>
            <Dialog as="div" className="fixed z-50 inset-0 overflow-y-auto" onClose={closeModal}>
                <div
                    className="flex items-center md:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div
                            className="inline-block relative align-bottom bg-gray-100 rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-2/3">
                            <div className="block absolute top-0 z-30 right-0 pt-1 pr-1 md:pt-4 md:pr-4">
                                <button
                                    type="button"
                                    className="bg-white rounded-lg p-1 transition-all ease-in-out duration-300 hover:bg-red-600 hover:text-white text-gray-400"
                                    onClick={closeModal}
                                >
                                    <span className="sr-only">Close</span>
                                    <XIcon className="h-7 w-7" aria-hidden="true"/>
                                </button>
                            </div>
                            <div
                                className="md:absolute flex flex-col justify-center md:-ml-16 w-full md:w-[55%] md:top-1/2 md:transform md:-translate-y-1/2 md:right-[55%] md:z-20">
                                <div
                                    className="md:absolute px-6 md:px-0 z-10 md:bottom-0 flex justify-center w-full my-2 md:transform md:translate-y-1/2">
                                    <Transition.Child
                                        as={Fragment}
                                        enter="ease-out duration-300 delay-500"
                                        enterFrom="opacity-0 translate-y-4 sm:scale-95"
                                        enterTo="opacity-100 translate-x-0 sm:scale-100"
                                        leave="ease-in duration-200"
                                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    >
                                        <img
                                            className="max-h-[150px] object-scale-down max-w-[300px] p-4 shadow rounded-lg bg-white"
                                            loading="lazy" src={ASSETS_BASE_URL + 'xhdpi/' + currentItem.company.logo}
                                            alt="logo"/>
                                    </Transition.Child>
                                </div>
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300 delay-300"
                                    enterFrom="opacity-0 -translate-x-4 sm:scale-95"
                                    enterTo="opacity-100 translate-x-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <img className=" relative shadow rounded-lg px-2 md:px-0"
                                         loading="lazy" src={ASSETS_BASE_URL + 'xxhdpi/' + currentItem.image} alt=""/>
                                </Transition.Child>
                            </div>
                            <div className="sm:p-6 w-full h-full overflow-y-auto max-h-[550px]">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300 delay-500"
                                    enterFrom="opacity-0 translate-x-4"
                                    enterTo="opacity-100 translate-x-0"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <div className="sm:flex">
                                        <div className="md:w-1/2"></div>
                                        <div
                                            className="mt-3 w-full px-4 md:px-0 md:w-1/2 flex flex-col text-center sm:mt-0 sm:text-left">
                                            <div className="flex">
                                                <div className="w-full">
                                                    <Dialog.Title as="h3"
                                                                  className="leading-6 my-1 font-bold text-2xl mt-3 text-gray-900">
                                                        {currentItem.company.name}
                                                    </Dialog.Title>
                                                    {/*TODO: tags + getCategory*/}
                                                    {/*<span className="text-gray-400 text-sm">Kategorie: <a*/}
                                                    {/*    className="text-red-400 transition-all ease-in-out duration-300 hover:underline"*/}
                                                    {/*    href={'#' + company.category}>{company.category}</a></span>*/}
                                                    <div className="flex flex-col text-base my-2">
                                                        <span>{currentItem.companyLocation.street}</span>
                                                        <span>{currentItem.companyLocation.postalCode + ' ' + currentItem.companyLocation.city}</span>
                                                        <a href={'tel:' + currentItem.companyLocation.telephone}>{currentItem.companyLocation.telephone}</a>
                                                        <a className="text-red-600"
                                                           target="_blank"
                                                           href={currentItem.company.website}>{currentItem.company.website}</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-col my-4 offer-description__container">
                                                <span className="font-bold text-xl my-2">Angebotbeschreibung:</span>
                                                <div className="px-6"
                                                     dangerouslySetInnerHTML={{__html: currentItem.description}}></div>
                                            </div>
                                            <div className="divide-y divide-gray-200 my-4">
                                                <span className="font-bold text-base">Standorte</span>

                                                <div className="flex flex-col">
                                            <span className="flex items-center">
                                                    <LocationMarkerIcon className="h-4 w-4 mr-1 text-red-600"
                                                                        aria-hidden="true"/>
                                                {currentItem.companyLocation.street + ' ' + currentItem.companyLocation.postalCode + ' ' + currentItem.companyLocation.city}
                                            </span>
                                                    <span className="flex items-center">
                                                 <PhoneIcon className="h-4 w-4 mr-1 text-red-600" aria-hidden="true"/>
                                                 <a href={'tel:' + currentItem.companyLocation.telephone}>{currentItem.companyLocation.telephone}</a>
                                            </span>
                                                </div>
                                            </div>
                                            <AppDownloadBanner></AppDownloadBanner>
                                            {currentItem.companyLocation.latitude && currentItem.companyLocation.latitude && (
                                                <div className="flex w-full items-center flex-col my-4">
                                                    <span className="font-bold text-xl my-2">So finden Sie uns:</span>
                                                    <GoogleMapsWidget lat={currentItem.companyLocation.latitude}
                                                                      lng={currentItem.companyLocation.longitude}></GoogleMapsWidget>
                                                </div>)}
                                        </div>
                                    </div>
                                </Transition.Child>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
